import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPills20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconPills20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.45 9.5H2.5v1h1.95zM2.5 8A1.5 1.5 0 0 0 1 9.5v1A1.5 1.5 0 0 0 2.5 12h1.95a1.5 1.5 0 0 0 1.5-1.5v-1A1.5 1.5 0 0 0 4.45 8zm8.7 1.5H8.8v1h2.4zM8.8 8a1.5 1.5 0 0 0-1.5 1.5v1A1.5 1.5 0 0 0 8.8 12h2.4a1.5 1.5 0 0 0 1.5-1.5v-1A1.5 1.5 0 0 0 11.2 8zm6.75 1.5h1.95v1h-1.95zm-1.5 0a1.5 1.5 0 0 1 1.5-1.5h1.95A1.5 1.5 0 0 1 19 9.5v1a1.5 1.5 0 0 1-1.5 1.5h-1.95a1.5 1.5 0 0 1-1.5-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPills20);
